// extracted by mini-css-extract-plugin
export default {"root":"QuestionList_root__-4YHp","message":"QuestionList_message__UrDcV"};